import React from "react";
import { HorizontalSlider } from "../../components";
import "./aboutTeams.css";
// import "../Sponsors/animate.css";
export default function AboutTeams() {
  const data = [
    {
      src: "/image/ken-cheung-KonWFWUaAuk-unsplash.jpg",
      teamName: "वक्तृत्व समूह(Oratory Team)",
      text: "वक्तृत्व समूह (Oratory Team) समिति के प्रतिनिधित्व में अहम भूमिका निभाता है । संस्थान में आयोजित सभी कार्यक्रम में मंच संचालन का कार्यभार वक्तृत्व दल द्वारा ही संभाला जाता है। साथ ही इस दल के सदस्य भरे मंच पर आकर्षक एवं मनोरंजन प्रस्तुति देने का कौशल रखते हैं। इन प्रस्तुतियों में शायरी, ग़ज़ल, गीत, कविता सभी प्रकार के रस दिखाई देते हैं । लेखन दल द्वारा लिखे गए विचारों को आवाज़ देने का काम वक्तृत्व दल का होता हैं। यह दल वक्ता को अपने विचारों को प्रभावी रूप से व्यक्त करने में निपुण बनाता है",
    },
    {
      src: "/image/simon-berger-twukN12EN7c-unsplash.jpg",
      teamName: "रूपांकन समूह(Design Team)",
      text: "हिन्दी साहित्यिक एवं वाद विवाद समिति रूपांकन समूह का मुख्य उद्देश्य छात्रों को उनके कलात्मक कौशल को बढ़ाने के लिए एक वातावरण प्रदान करना है|  रूपांकन समूह समिति के सभी प्रकार के पोस्टर एवम् वीडियो संपादन के कार्यभार का संवहन करता है|  समिति के सोशल मीडिया पर साझा किए जाने वाली सभी पोस्ट रूपांकन समूह तैयार करता है | वार्षिक सांस्कृतिक उत्सव काॅन्फ़्लुएन्स पर समिति द्वारा आयोजित विभिन्न स्पर्धायो के पोस्टर भी रूपांकन समूह द्वारा ही बनाए जाते हैं | ",
    },

    {
      src: "/image/ken-cheung-KonWFWUaAuk-unsplash.jpg",
      teamName: "लेखन समूह",
      text: "लेखन समूह हिंदी साहित्य एवं वाद-विवाद समिति का मस्तिष्क रूप है , जो विचार और रचना रस को शब्दों में पिरोने का कार्य करता है। कार्यक्रमों पर एंकरिंग की पटकथा(script) तैयार करने में विशेष भूमिका निभाता है। इसके अलावा अपने कनिष्ठ नव लेखकों को तैयार करने के लिए लेखन कार्यशाला आयोजन करवाता है। Confluence में HLAD के विभिन्न लेखन संबंधी प्रतियोगिताओं को करवाने में मुख्य भूमिका निभाता है, एनआईटी में आयोजित कार्यक्रमों से संबंधित अखबारों में छपने वाली रिपोर्ट्स को लिखने का  अत्यंत रोचक और अनूठा कार्य भी लेखन समूह की ही जिम्मेदारी होती हैं | उत्कृष्ट संवेदनशील रचनात्मक लेखकों से युक्त हमारी ये समूह लेखन को सेवा -धर्म समझते हुए HLAD  के एक मुख्य  आधार का कार्य करता है |",
    },
  ];

  /*To display read more card*/

  function show(i) {
    document.getElementById("readMore").classList.toggle("hidden");
    document.getElementById("image").src = data[i].src;
    document.getElementById("teamName").innerHTML = data[i].teamName;
    document.getElementById("text").innerHTML = data[i].text;
  }

  /*To hide read more card*/
  function hide(event) {
    if (event.target == event.currentTarget) {
      document.getElementById("readMore").classList.toggle("hidden");
    }
  }

  /*For animation*/
  const boxes = document.querySelectorAll(".order");
  const triggerBottom = (window.innerHeight / 5) * 4;
  function checkBoxes() {
    boxes.forEach(function (box, i) {
      const boxTop = box.getBoundingClientRect().top;
      if (boxTop < triggerBottom) {
        if (i % 2 === 0) {
          box.classList.add("animate__fadeInLeft");
        } else {
          box.classList.add("animate__fadeInRight");
        }
      } else {
        box.classList.remove("animate__fadeInRight");
        box.classList.remove("animate__fadeInLeft");
      }
    });
  }
  return (
    <HorizontalSlider
      data={data}
      heading=""
      minHeight=""
      scaleWidth={0.7}
      hideSlideButtons={true}
      renderComponent={(teamData, i) => (
        <div
          key={`teamData-${i}`}
          className="shadowCss"
          style={{
            minWidth: "200px",
            maxHeight: "500px",
            height: "400px",
            backgroundColor: "white",
            overflow: "scroll",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              className="shadowCss"
              src={teamData.src}
              alt=""
              style={{
                height: "60px",
                width: "60px",
                borderRadius: "50%",
                margin: "20px",
                borderWidth: "1px",
                borderColor: "#d0d0d0",
                objectFit: "cover",
              }}
            />
            <h2 style={{ fontWeight: "bold", color: "rgba(0,0,0,0.7)" }}>
              {teamData.teamName}
            </h2>
          </div>
          <p
            style={{
              color: "rgba(0,0,0,0.7)",
              margin: "20px",
              marginTop: "0px",
            }}
          >
            {teamData.text}
          </p>
        </div>
      )}
    />
  );
  return (
    <div
      className="border-t-2 border-solid border-gray-200"
      onWheel={checkBoxes}
    >
      <h2 className="text-gray-900 text-4xl font-bold text-center title mt-20">
        Our Teams
      </h2>
      {data.map((sdata, i) => (
        <div
          key={i}
          id="container"
          className="border-0 rounded order mx-auto my-10 py-3 w-4/5 text-justify flex-wrap relative animate__animated"
        >
          <div className="m-auto teamImage">
            <img
              alt=""
              id="pic"
              className="w-full h-full rounded-full"
              src={sdata.src}
            />
          </div>
          <div className="px-2 lg:w-2/3 lg:h-full overflow-hidden">
            <div className="font-bold text-xl text-center py-2">
              {sdata.teamName}
            </div>
            <div className="text-base">
              <span className="hidden md:inline">
                {sdata.text.substring(0, 720)}
              </span>
              <span className="inline md:hidden">
                {sdata.text.substring(0, 300)}
              </span>
              <a href="#readMore">
                <span
                  className="font-bold text-blue-500 hidden md:inline"
                  onClick={() => show(i)}
                >
                  {sdata.text.length > 720 ? "...Read More>>" : ""}
                </span>
                <span
                  className="font-bold text-blue-500 inline md:hidden"
                  onClick={() => show(i)}
                >
                  {sdata.text.length > 300 ? "...Read More>>" : ""}
                </span>
              </a>
            </div>
          </div>
        </div>
      ))}

      {/*Read more card*/}

      <div
        className="hidden w-screen h-screen cover fixed inset-y-0 z-10 modal"
        style={{ zIndex: "200" }}
        id="readMore"
        onClick={hide}
      >
        <div className="border-0 scroll h-4/5 bg-white readMore w-5/6 md:w-1/2 lg:w-2/5 m-auto my-10 text-justify flex-wrap relative ...">
          <div className="bg-white sticky top-0 flex">
            <button
              className="w-6 h-6 text-xl font-bold z-10 text-white bg-red-100 hover:bg-red-500 flex justify-center items-center absolute top-0 right-0"
              onClick={hide}
            >
              x
            </button>
            <div
              style={{
                height: "64px",
                width: "80px",
                borderRadius: "50px",
                margin: "10px",
              }}
            >
              <img
                alt=""
                id="image"
                className=" h-full w-full rounded-full"
                src=""
              />
            </div>
            <div id="teamName" className="px-3 w-full text-3xl teamName1"></div>
          </div>
          <hr />
          <div id="text" className="px-3 text-lg teamText1"></div>
        </div>
      </div>
    </div>
  );
}
